module.exports = __webpack_public_path__ + "static/media/profilepic.cb0caa49.png";